import { render, staticRenderFns } from "./GatGridFooter.vue?vue&type=template&id=7d2226a1&scoped=true&"
import script from "./GatGridFooter.vue?vue&type=script&lang=js&"
export * from "./GatGridFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2226a1",
  null
  
)

export default component.exports